import React from 'react';
import { brand } from '../branding';

// Shared page footer; the text and link follow the site's brand (branding.js).
function Footer() {
  return (
    <div className="footer">
      <a href={brand.websiteUrl} className="custom-link" target="_blank" rel="noopener noreferrer">
        {brand.copyright}
      </a>
    </div>
  );
}

export default Footer;
